/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts" />

module Meevo.Plugins.Product {
    "use strict";

    /**
    * Compensation Section of PackageTypes 
    */
    export class CompensationSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.ProductCompensation> {
        private modalService: Meevo.Components.Modal.IModalService;
        public enrollmentFee: Meevo.Model.ProductCompensationSetting;

        constructor(sectionId: number, displayNameContentKey: string, template: string, isPrimarySection: boolean,
            handlesOwnCrud: boolean, baseEndpoint: string, sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey?: string) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);

            this.modalService = modalService;

        }

        commissionsOverride(list: any): void {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/components/compensation/commissionOverrideModal.template.html",
                clickOutsideToClose: true,
                controller: "meevo.components.compensation.CommissionsOverrideModalController",
                controllerAs: "vm",
                locals: {
                    employees: angular.copy(list)
                }
            }

            this.modalService.showCustom(options).then((response: any) => {
                if (response.status === true) {
                    list.length = 0;
                    list.push.apply(list, response.employees);
                }
            });
        }

        sectionModelRetrieved(): void {

            _.each(this.model.productCompensationSetting, (set) => {
                switch (set.productCommissionSetting) {
                    case Meevo.Model.CommissionsSettingEnum.EnrollmentFee:
                        this.enrollmentFee = set;
                        break;
                }
            });           
        }

        preSave(): void {
            super.preSave()

        }


    }
}